import React from "react";
import { Alert, Snackbar } from "@mui/material";
import { useUI } from "context/ui/uiContext";

/**
 * UserAlert component to display alerts.
 */
function UserAlert() {
  const { open, message, severity, closeAlert } = useUI();

  if (!message) {
    return null; // Return null to prevent rendering anything if there is no message
  }

  return (
    <Snackbar
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      open={open}
      autoHideDuration={6000}
      onClose={closeAlert}
    >
      <Alert
        onClose={closeAlert}
        severity={severity}
        sx={{ width: "100%" }}
        variant="filled" // Use 'filled' to give it a solid color background
      >
        {message || "An unexpected error occurred"}
      </Alert>
    </Snackbar>
  );
}

export default UserAlert;
